export default "__VITE_ASSET__BaxfZiAC__"